import React, { useState, useEffect } from 'react';
import { collection, query, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Image as ImageIcon, Lock, Heart, LogIn } from 'lucide-react';
import PublicGateModal from './PublicGateModal';

// 비회원 공개 — 보철 갤러리 (상세는 로그인)
function PublicGallery() {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [gate, setGate] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const snap = await getDocs(query(
                    collection(db, 'labPosts'),
                    orderBy('createdAt', 'desc'),
                    limit(40)
                ));
                setPosts(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(p => p.photos?.[0]));
            } catch (e) { console.error('갤러리 로드 실패:', e); }
            setLoading(false);
        })();
    }, []);

    const openGate = () => setGate({
        title: '갤러리 상세는 회원 전용이에요',
        desc: '로그인하면 작업 설명, 사용 재료, 기공소 정보까지 모두 확인할 수 있습니다.',
    });

    return (
        <div style={S.page}>
            <header style={S.header}>
                <div style={S.headerInner}>
                    <button style={S.backBtn} onClick={() => navigate('/')}>
                        <ArrowLeft size={18} /> 홈
                    </button>
                    <div style={S.headerTitleWrap}>
                        <ImageIcon size={20} color="#3b82f6" />
                        <h1 style={S.headerTitle}>보철 갤러리</h1>
                    </div>
                    <button style={S.loginTop} onClick={() => navigate('/login')}>
                        <LogIn size={15} /> 로그인
                    </button>
                </div>
            </header>

            <main style={S.main}>
                <p style={S.lead}>전국 기공소가 직접 올린 실제 작업물입니다. 실력을 눈으로 확인하세요.</p>

                {loading ? (
                    <div style={S.emptyBox}>불러오는 중...</div>
                ) : posts.length === 0 ? (
                    <div style={S.emptyBox}>
                        <ImageIcon size={32} color="#cbd5e1" />
                        <p style={{ margin: '10px 0 0' }}>아직 공개된 게시물이 없습니다.</p>
                    </div>
                ) : (
                    <div style={S.grid}>
                        {posts.map(post => (
                            <div key={post.id} className="pg-item" style={S.item} onClick={openGate}>
                                <img src={post.photos[0]} alt="" style={S.img} loading="lazy" />
                                <div style={S.overlay}>
                                    <span style={S.stat}><Heart size={13} fill="#fff" color="#fff" /> {post.likes || 0}</span>
                                    <span><Lock size={13} color="#fff" /></span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </main>

            <PublicGateModal gate={gate} onClose={() => setGate(null)} />
            <style>{`
                .pg-item { transition: transform 0.15s ease; }
                .pg-item:hover { transform: scale(1.02); }
            `}</style>
        </div>
    );
}

const S = {
    page: { minHeight: '100vh', backgroundColor: '#f8fafc' },
    header: { position: 'sticky', top: 0, zIndex: 50, backgroundColor: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(10px)', borderBottom: '1px solid #e2e8f0' },
    headerInner: { maxWidth: 1100, margin: '0 auto', padding: '0 20px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 },
    backBtn: { display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', fontSize: 14, fontWeight: 600, color: '#475569', cursor: 'pointer', padding: '8px 10px' },
    headerTitleWrap: { display: 'flex', alignItems: 'center', gap: 8 },
    headerTitle: { margin: 0, fontSize: 18, fontWeight: 800, color: '#0f172a' },
    loginTop: { display: 'flex', alignItems: 'center', gap: 6, padding: '9px 16px', backgroundColor: '#3b82f6', color: '#fff', border: 'none', borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: 'pointer' },

    main: { maxWidth: 1100, margin: '0 auto', padding: '32px 20px 80px' },
    lead: { margin: '0 0 24px', fontSize: 15, color: '#64748b', lineHeight: 1.6 },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 },
    item: { position: 'relative', aspectRatio: '1', borderRadius: 14, overflow: 'hidden', cursor: 'pointer', backgroundColor: '#e2e8f0' },
    img: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
    overlay: { position: 'absolute', left: 0, right: 0, bottom: 0, padding: '24px 12px 10px', background: 'linear-gradient(transparent, rgba(0,0,0,0.6))', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    stat: { display: 'inline-flex', alignItems: 'center', gap: 4, color: '#fff', fontSize: 13, fontWeight: 600 },
    emptyBox: { padding: '80px 20px', textAlign: 'center', color: '#94a3b8', fontSize: 14, display: 'flex', flexDirection: 'column', alignItems: 'center' },
};

export default PublicGallery;
